// super simple module for the most common nodejs use case.
exports.markdown = require("./markdown");
exports.parse = exports.markdown.toHTML;



//////////////////
// WEBPACK FOOTER
// ./~/markdown/lib/index.js
// module id = 34
// module chunks = 95715928098905 186809051687896 221494691356687